// Støtter pathnames med ett og to nivå, eks '/reports' og '/orders/labels'.
export const extractNavlinkDisplayName = (pathname) =>
  pathname.split('/')[2] ?? pathname.split('/')[1];
